/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_WeightInputs */

const en_platform_view_weight = /** @type {(inputs: Platform_View_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const pl_platform_view_weight = /** @type {(inputs: Platform_View_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waga`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Platform_View_WeightInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_weight = /** @type {((inputs?: Platform_View_WeightInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_WeightInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_weight(inputs)
	return en_platform_view_weight(inputs)
});